<template>
  <section class="why-section">
    <div class="section-container">
      <div class="section-header">
        <span class="section-label">Pourquoi nous choisir</span>
        <h2 class="section-title">Pourquoi choisir OASIS FINANCE ?</h2>
        <p class="section-subtitle">
          Nous offrons des solutions financières adaptées aux réalités locales, 
          alliant proximité, transparence et performance.
        </p>
      </div>

      <div class="why-grid">
        <div 
          class="why-card" 
          v-for="(item, index) in reasons" 
          :key="index"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div class="why-number">{{ String(index + 1).padStart(2, '0') }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhySection',
  data() {
    return {
      reasons: [
        {
          title: 'Transparence Totale',
          description: 'Aucun frais caché, des conditions claires et une communication ouverte sur tous nos produits et services.'
        },
        {
          title: "Rapidité d'Exécution",
          description: 'Décisions en 24h, déblocage rapide des fonds. Nous comprenons l\'urgence de vos besoins financiers.'
        },
        {
          title: 'Proximité & Écoute',
          description: 'Une équipe dédiée et à votre écoute pour vous accompagner dans tous vos projets personnels et professionnels.'
        },
        {
          title: 'Taux Compétitifs',
          description: 'Des taux d\'intérêt parmi les plus bas du marché, adaptés à votre profil et à la durée de votre prêt.'
        },
        {
          title: 'Sécurité Garantie',
          description: 'Vos épargnes sont sécurisées et vos données protégées selon les normes les plus strictes du secteur.'
        },
        {
          title: 'Expertise Locale',
          description: 'Depuis 2019, nous accompagnons les communautés de Ngaoundéré avec une connaissance approfondie du terrain.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.why-section {
  padding: 6rem 2rem;
  background: var(--white);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 4rem;
}

.section-label {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: rgba(37, 99, 235, 0.1);
  color: var(--accent-blue);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-radius: 50px;
  margin-bottom: 1rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: var(--gray-900);
  line-height: 1.2;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--gray-600);
  line-height: 1.7;
}

.why-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.why-card {
  position: relative;
  padding: 2rem;
  background: var(--white);
  border: 1px solid var(--gray-100);
  border-radius: 20px;
  transition: var(--transition-base);
  overflow: hidden;
}

.why-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-blue), var(--accent-blue));
  transform: scaleX(0);
  transition: var(--transition-base);
}

.why-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-xl);
  border-color: transparent;
}

.why-card:hover::before {
  transform: scaleX(1);
}

.why-number {
  font-family: var(--font-display);
  font-size: 3rem;
  font-weight: 700;
  color: var(--gray-100);
  margin-bottom: 1rem;
  transition: var(--transition-base);
}

.why-card:hover .why-number {
  color: var(--gray-200);
}

.why-card h3 {
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: 0.75rem;
}

.why-card p {
  font-size: 0.95rem;
  color: var(--gray-600);
  line-height: 1.7;
}

@media (max-width: 1024px) {
  .why-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .why-section {
    padding: 4rem 1.5rem;
  }

  .why-grid {
    grid-template-columns: 1fr;
  }
}
</style>
